import type { AuditSummaryStats } from "@/modules/internal-audit/domain/repo/summary/get-stats";
import { Button, Card } from "@devhop/ui";
import { AlertCircle, Building2 } from "lucide-react";

type AuditSummaryDepartmentsProps = {
  stats: AuditSummaryStats;
  onDepartmentClick: (departmentId: string) => void;
};

export function AuditSummaryDepartments({
  stats,
  onDepartmentClick,
}: AuditSummaryDepartmentsProps) {
  const { departmentsWithProblems } = stats;

  if (departmentsWithProblems.length === 0) return null;

  const maxIssueCount = Math.max(
    ...departmentsWithProblems.map((d) => d.issueCount),
    1,
  );

  return (
    <Card className="p-6" data-tourid="summary-departments">
      <div className="mb-4 flex items-center gap-2">
        <Building2 className="h-5 w-5 text-blue-500" />
        <h2 className="font-semibold text-lg">ຜະແນກທີ່ມີບັນຫາຊ້ຳຊ້ອນ</h2>
      </div>
      <div className="space-y-3">
        {departmentsWithProblems.map((dept) => (
          <div
            key={dept.departmentId}
            className="flex items-center justify-between rounded-lg border bg-card p-4"
          >
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-medium">{dept.departmentName}</span>
                {dept.openIssueCount > 0 && (
                  <span className="flex items-center gap-1 rounded-full bg-orange-100 px-2 py-0.5 text-orange-700 text-xs">
                    <AlertCircle className="h-3 w-3" />
                    {dept.openIssueCount} ບັນຫາທີ່ຍັງບໍ່ແກ້ໄຂ
                  </span>
                )}
              </div>
              <div className="mt-2 flex items-center gap-2">
                <span className="text-muted-foreground text-sm">
                  ຈຳນວນບັນຫາ: {dept.issueCount}
                </span>
                <div className="h-2 max-w-[200px] flex-1 overflow-hidden rounded-full bg-muted">
                  <div
                    className="h-full bg-blue-500 transition-all"
                    style={{
                      width: `${(dept.issueCount / maxIssueCount) * 100}%`,
                    }}
                  />
                </div>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onDepartmentClick(dept.departmentId)}
            >
              ເບິ່ງບັນຫາ
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
}
